import numeral from "numeral";
import React from "react";
import RespondTo from "./respond-to";

const PoolActivityNumbers = ({
  interactionTotalByPool,
  prospectsWithInteractions,
  prospectsTotal,
  activityCoverage,
}) => {
  return (
    <>
      <div>
        <div className="pool-report--label">Prospects w/ Logged Activity</div>
        <div className="pool-report--large-num">
          {typeof activityCoverage !== "undefined"
            ? activityCoverage
            : numeral(prospectsWithInteractions / prospectsTotal).format("%0.[00]")}
        </div>
      </div>

      <div>
        <RespondTo className="pool-report--label pool-activity-report--logged">Activity Logged</RespondTo>
        <div className="pool-report--large-num">{interactionTotalByPool}</div>
      </div>
    </>
  );
};

export default PoolActivityNumbers;
